( function( $ ) {
	let $announcementBar = $( '.announcement-bar' );

	const loadSlider = () => {
		new Swiper ( $announcementBar.find( '.swiper' )[0], {
			direction: 'vertical',
			loop: true,
			speed: 1000,
			allowTouchMove: false,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
		} );
	};

	if ( !sessionStorage.getItem( 'promo_popup_shown' ) ) {
		let $promoPopup = $( '.modal-promo' );
		let $promoPopupContent = $promoPopup.find( '.modal-body' );

		setTimeout( function() {
			$promoPopup.modal( 'show' );
		}, 150 );

		$promoPopupContent.click( () => {
			$promoPopup.modal( 'hide' );
		} );

		$promoPopup.on( 'hidden.bs.modal', () =>  {
			sessionStorage.setItem( 'promo_popup_shown', 'true' );
		} );
	}

	window.app.loadVendor( 'Swiper', loadSlider );
} )( jQuery );